import { STRIPE_VALIDATION_ERROR_MAP } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const getStripeErrorMessage = (error) => {
  if (!error) {
    return;
  }

  const { code } = error;
  const errorMessage = STRIPE_VALIDATION_ERROR_MAP[code] ?? STRIPE_VALIDATION_ERROR_MAP.defaultMessage;

  return errorMessage;
};
